import { useState, useEffect } from 'react'
import { toast } from '@sales-center/components'
import { RequestStatus } from '@sales-center/common'
import { ActivityType } from '@user/features/Activity/ActivitiyTypes/typings'
import { getActivityTypesUrl } from '../constants'
import { get, isAPIError } from '@sales-center/common'

export const useFetchActivityTypesOnMount = () => {
  const [status, setStatus] = useState<RequestStatus>('idle')
  const [activityTypes, setActivityTypes] = useState<ActivityType[]>([])
  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        setStatus('loading')
        const response = await get(`${getActivityTypesUrl}`)
        const result = await response.json()

        if (mounted) {
          if (!isAPIError(result)) {
            setStatus('success')
            setActivityTypes(result)
          } else {
            setStatus('error')
            toast.error(`Failed to load activity types`)
          }
        }
      } catch (error) {
        if (mounted) {
          setStatus('error')
        }
      } finally {
        if (mounted) setStatus('idle')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [setActivityTypes, setStatus])

  return { activityTypes, status }
}
